import {menus} from "../../utils/menus";
import {Menu} from "antd";
import React from "react";
const HeadMenu = ({ path }) => {

    const jump = function (e) {
        // 页面跳转方法
        if (e.key.indexOf('http') === -1) {
            window.location.href = ('/' + e.key)
        } else {
            window.location.href = (e.key)
        }
    }
    return (
        <Menu onClick={jump} mode="horizontal" items={menus}/>
    )
}

export default HeadMenu
